__webpack_require__.p = "/square-game/";